import { View } from 'backbone.marionette';
import template from './index.jst';
import { Model, Collection } from 'backbone';
import RoundSlider from "../../../../core/views/components/RoundSlider";
import { Preloader } from "../../utils";
import MatchCentreDays from "./MatchCentreDays";
import './index.styl';
import Backbone from "backbone";
import { sizes_for_big_ad } from '../../../../core/utils';
import { AdvertisingView } from '../index';
// import _ from 'lodash';

// import Radio from "backbone.radio";
// const MATCH_CENTRE_CHANNEL = Radio.channel('match_centre');

export class MatchCentreLanding extends View {
	get template() {
		return template;
	}

	get className() {
		return 'match-centre-landing';
	}

	childViewEvents() {
		return {
			'round:changed': 'onRoundChanged'
		}
	}

	regions() {
		return {
			round_selector: '.js-rounds-select',
			ad_item: '.js-ad-item',
			matches: '.js-matches'
		}
	}

	initialize() {
		this.model = new Model();
		this.round_id = this.getOption('round_id');
		this.liveScoresIntervalId = null;

		this.setListeners()
			.setLayout()
			.initAd();

		this.getData();
	}

	setListeners() {
		this.listenTo(this, 'data:requested', this.onDataRequested);
		this.listenTo(this, 'rounds:updated', this.onRoundsUpdated);


		return this;
	}

	setLayout() {

		if (!this.getRegion('round_selector').hasView()) {
			this.showChildView('round_selector', new RoundSlider());
		}

		return this;
	}

	async getData() {
		Preloader.show();

		// const requests = _.invokeMap(
		// 	_.pick(this, 'rounds'),
		// 	'fetch'
		// );

		// await Promise.all(requests);

		await this.options.rounds.fetch();

		this.trigger('data:requested');

		Preloader.hide();
	}

	onDataRequested() {
		this.setSelectedRound()
			.checkRoundStatus()
			.groupMatches()
			.initLayouts();
	}

	onRoundsUpdated() {
		this.changeURL()
			.checkRoundStatus()
			.groupMatches()
			.initMatchDays();
	}

	setSelectedRound() {
		const preselected_round = this.options.rounds.get(this.round_id);
		this.selected_round = preselected_round || this.options.rounds.getActualRound();

		this.round_id = this.selected_round.get('id');

		return this;
	}

	groupMatches() {
		this.matches_by_date = this.selected_round.groupMatchesByDate();

		return this;
	}

	initLayouts() {
		this.initRoundSlider()
			.initMatchDays();
	}

	initRoundSlider() {
		this.getChildView('round_selector').init({
			rounds: this.options.rounds.toJSON(),
			selected: this.round_id
		});

		return this;
	}

	initMatchDays() {
		this.showChildView('matches', new MatchCentreDays({
			collection: new Collection(this.matches_by_date)
		}));
	}

	onRoundChanged(round_id) {
		this.round_id = round_id;
		this.selected_round = this.options.rounds.get(this.round_id);

		this.onRoundsUpdated();
	}

	checkRoundStatus() {
		if (this.selected_round.is_active) {
			this.subscribeToLiveUpdates();
		}
		else if (this.liveScoresIntervalId) {
			this.unsubscribeFromLiveUpdates();
		}
		return this;
	}

	subscribeToLiveUpdates() {
		clearTimeout(this.liveScoresIntervalId);

		let time = this.selected_round.active_match ? 1 : 5;

		this.liveScoresIntervalId = setTimeout(async () => {
			await this.options.rounds.fetch();

			this.trigger('rounds:updated');
		}, time * 1000 * 60);

	}

	unsubscribeFromLiveUpdates() {
		clearTimeout(this.liveScoresIntervalId);
	}

	changeURL() {
		const round_id = this.selected_round.get('id');

		let href = `/match-centre/${round_id}`;

		Backbone.history.navigate(href);

		return this;
	}

	initAd() {
		const advertising = new AdvertisingView({
			ad_id: 'match-centre-slot-3',
			ad_path: 'match-centre',
			size: sizes_for_big_ad(),
			pos: 3,
		});

		this.getRegion('ad_item').show(advertising);
	}

}

export default MatchCentreLanding;